import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { hexToRgbA, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    backgroundColor: hexToRgbA(theme.color.greys[80], 0.1),
    borderRadius: 16,
  }
}), { name: 'Skeleton', index: StylesIndexInjections.UI_ATOMS });
